// Author Shi Wenlong
// Date 2021-07-09 14:08:14

class SithMesQualityToolScrap {
constructor({
        id = null,
        toolId = '',
        scrapDate = '',
        scrapType = '',
        scrapReason = '',
        scrapApprover = '',
        scrapApplicant = '',
        remark = '',
        status = '',
        workOrderCode = ''}
= {}) {
    this.id = id;
    this.toolId = toolId;
    this.scrapDate = scrapDate;
    this.scrapType = scrapType;
    this.scrapReason = scrapReason;
    this.scrapApprover = scrapApprover;
    this.scrapApplicant = scrapApplicant;
    this.remark = remark;
    this.status = status;
    this.workOrderCode = workOrderCode;
}
}

function newEntity() {
return new SithMesQualityToolScrap();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'toolId',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.toolId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'scrapDate',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.scrapDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'scrapType',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.scrapType',
        sortable: true,
        form: {
            type: 'select',
            options: [{
                value: '校验常规报废',
                text: '校验常规报废'
            },
            {
                value: '自然损耗报废',
                text: '自然损耗报废'
            },
            {
                value: '丢失报废',
                text: '丢失报废'
            },
            {
                value: '异常损坏报废',
                text: '异常损坏报废'
            },
            {
                value: '其他',
                text: '其他'
            }]
        }
        },
        {
        key: 'scrapReason',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.scrapReason',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'scrapApprover',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.scrapApprover',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'scrapApplicant',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.scrapApplicant',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'status',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'statusName',
        label: 'label.sith.quality.sithMesQualityToolScrap.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    toolIdFilter : "",
    scrapDateRteFilter : "",
    scrapDateLteFilter : "",
    scrapTypeFilter : "",
    scrapReasonFilter : "",
    scrapApproverFilter : "",
    scrapApplicantFilter : "",
    statusFilter : "",
    workOrderCodeFilter : "",
    workflowQueryTypeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'toolIdFilter',
        label: 'label.sith.quality.sithMesQualityToolScrap.filter.toolId',
        disabled: false,
        form: {
            type: 'input'
                }
        },
        {
        key: 'scrapDateRteFilter',
        label: 'label.sith.quality.sithMesQualityToolScrap.filter.scrapDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'scrapDateLteFilter',
        label: 'label.sith.quality.sithMesQualityToolScrap.filter.scrapDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'scrapTypeFilter',
        label: 'label.sith.quality.sithMesQualityToolScrap.filter.scrapType',
        disabled: false,
        form: {
            type: 'select',
            options: [{
                value: '校验常规报废',
                text: '校验常规报废'
            },
            {
                value: '自然损耗报废',
                text: '自然损耗报废'
            },
            {
                value: '丢失报废',
                text: '丢失报废'
            },
            {
                value: '异常损坏报废',
                text: '异常损坏报废'
            },
            {
                value: '其他',
                text: '其他'
            }]
        }
        },
        {
        key: 'scrapReasonFilter',
        label: 'label.sith.quality.sithMesQualityToolScrap.filter.scrapReason',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'scrapApproverFilter',
        label: 'label.sith.quality.sithMesQualityToolScrap.filter.scrapApprover',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'scrapApplicantFilter',
        label: 'label.sith.quality.sithMesQualityToolScrap.filter.scrapApplicant',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.quality.sithMesQualityToolScrap.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'SithMesQualityToolScrap',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.sith.quality.sithMesQualityToolScrap.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'toolId',
        label: 'label.sith.quality.sithMesQualityToolScrap.entity.toolId',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
        },
        {
        key: 'scrapDate',
        label: 'label.sith.quality.sithMesQualityToolScrap.entity.scrapDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'scrapType',
        label: 'label.sith.quality.sithMesQualityToolScrap.entity.scrapType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: [{
                value: '校验常规报废',
                text: '校验常规报废'
            },
            {
                value: '自然损耗报废',
                text: '自然损耗报废'
            },
            {
                value: '丢失报废',
                text: '丢失报废'
            },
            {
                value: '异常损坏报废',
                text: '异常损坏报废'
            },
            {
                value: '其他',
                text: '其他'
            }]
        }
        },
        {
        key: 'scrapReason',
        label: 'label.sith.quality.sithMesQualityToolScrap.entity.scrapReason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'scrapApprover',
        label: 'label.sith.quality.sithMesQualityToolScrap.entity.scrapApprover',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'scrapApplicant',
        label: 'label.sith.quality.sithMesQualityToolScrap.entity.scrapApplicant',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityToolScrap.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
]

export {SithMesQualityToolScrap, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
